import React from 'react';
import styled from 'styled-components';
import { mq } from '../../../../../../common/src/utils/styledComponentsUtils';

// Components
import OptionButton from '../../../../../../common/src/components/OptionButton';
import AccidentForm from './AccidentForm';
import AccidentDisplay from './AccidentDisplay';
import DashedButtonModal from './DashedButtonModal';

// Types
import { useTranslation } from 'react-i18next';
import { PiaClaim } from './PiaClaimsInputComponent';
interface Props {
  isMobile?: boolean;
  isEditing: boolean;
  setIsEditing: (arg0: boolean) => void;
  accident: PiaClaim;
  handleEdit: (arg0: PiaClaim) => void;
  handleRemove: () => void;
}

const SingleAccident: React.FC<React.PropsWithChildren<Props>> = ({
  isMobile,
  accident,
  isEditing,
  handleEdit,
  handleRemove,
  setIsEditing,
}) => {
  const { t } = useTranslation();

  const finishEdit = (accident: PiaClaim) => {
    setIsEditing(false);
    handleEdit(accident);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handleMobileClick = () => {
    if (isMobile) setIsEditing(true);
  };

  if (isMobile) {
    return (
      <>
        {isEditing && (
          <DashedButtonModal isOpen={isEditing}>
            <AccidentForm
              accident={accident}
              isMobile={isMobile}
              handleSave={finishEdit}
              handleRemove={handleRemove}
              handleCancel={handleCancel}
            />
          </DashedButtonModal>
        )}
        <Container data-test-id="ProdFac_SingleAccident_Element">
          <AccidentDisplay accident={accident} onClick={handleMobileClick} />
        </Container>
      </>
    );
  }

  if (isEditing)
    return (
      <AccidentForm
        accident={accident}
        handleSave={finishEdit}
        handleRemove={handleRemove}
        handleCancel={handleCancel}
      />
    );

  return (
    <Container>
      <AccidentDisplay accident={accident} onClick={handleMobileClick} />
      <OptionButton
        editText={t('Edit accident')}
        removeText={t('Remove accident')}
        onEdit={() => setIsEditing(true)}
        onRemove={handleRemove}
      />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  padding: 1.2rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04), 0 0 2px rgba(0, 0, 0, 0.06),
    0 0 1px rgba(0, 0, 0, 0.04);
  background-color: white;

  ${mq.mobileL} {
    justify-content: center;
    width: 28rem;
    height: 22.8rem;
    border-radius: 6px;
  }
`;

export default SingleAccident;
